import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import bg from 'src/assets/images/bg_login.jpg';
import bgSitech from 'src/assets/images/sitech_bg.jpg';
import { CConfig } from 'src/constants';
import { ESystemName } from 'src/types/enum';

const isSitech = CConfig.systemName === ESystemName.SITECH;
const isHoiAn = CConfig.systemName === ESystemName.HOIAN;

export const useStyles = makeStyles<Theme>(() => ({
  root: {
    background: `url(${isSitech || isHoiAn ? bgSitech : bg})`,
    backgroundSize: 'cover',
    height: '100vh',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
}));
